<template>
  <UContainer :dir="dir" class="py-16 sm:py-20">
    <div class="mx-auto flex w-full max-w-2xl flex-col items-center justify-center gap-4">
      <div class="w-full space-y-6 text-center sm:text-start">
        <h1
          v-if="resolvedTitle"
          class="text-2xl font-semibold text-highlighted sm:text-start"
        >
          {{ resolvedTitle }}
        </h1>

        <div class="space-y-4">
          <div v-if="resolvedPhone">
            <p
              v-if="resolvedPhoneLabel"
              class="text-sm font-medium text-muted"
            >
              {{ resolvedPhoneLabel }}
            </p>
            <a
              :href="`tel:${phoneHref}`"
              class="mt-1 inline-block text-base font-semibold text-highlighted hover:underline"
            >
              {{ resolvedPhone }}
            </a>
          </div>

          <div v-if="resolvedAddress">
            <p
              v-if="resolvedAddressLabel"
              class="text-sm font-medium text-muted"
            >
              {{ resolvedAddressLabel }}
            </p>
            <p class="mt-1 text-base leading-relaxed text-default">
              {{ resolvedAddress }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </UContainer>
</template>

<script setup lang="ts">
const dir = useDir()
const pageLocale = useState<string>('page-locale', () => 'fa')

type LocalizedString = string | Record<string, string>

const props = defineProps<{
  title?: LocalizedString
  phone?: LocalizedString
  phoneLabel?: LocalizedString
  address?: LocalizedString
  addressLabel?: LocalizedString
}>()

function resolveVal(value: unknown, loc: string): string {
  if (value == null) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'object') {
    const rec = value as Record<string, unknown>
    if (rec[loc] !== undefined) return String(rec[loc])
    const first = Object.values(rec)[0]
    return first != null ? String(first) : ''
  }
  return String(value)
}

const resolvedTitle = computed(() => resolveVal(props.title, pageLocale.value))
const resolvedPhone = computed(() => resolveVal(props.phone, pageLocale.value))
const resolvedPhoneLabel = computed(() => resolveVal(props.phoneLabel, pageLocale.value))
const resolvedAddress = computed(() => resolveVal(props.address, pageLocale.value))
const resolvedAddressLabel = computed(() => resolveVal(props.addressLabel, pageLocale.value))

const phoneHref = computed(() =>
  resolvedPhone.value.replace(/[^\d+]/g, '') || resolvedPhone.value,
)
</script>
